import React from 'react';
import {Redirect} from 'react-router-dom';
import Table, {TableBody, TableCell, TableHead, TableRow} from 'material-ui/Table';
import ContainerHeader from 'components/ContainerHeader/index';
import {PostData} from '/home/sygitech/Downloads/v-1.5/jumbo-react/source/src/Service/PostData';


class Default extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            id : '',
            profileData : '',
            edit : false,
            first_name : '',
            last_name : '',
            mobile : '',
            address : '',
            panCard : '',
            gender : '',
            license_no : '',

        };
        this.editProfile = this.editProfile.bind(this);
        this.onChange = this.onChange.bind(this);
        this.save = this.save.bind(this);
    }
    componentDidMount() {
        this.showProfile();
    }    
    showProfile() {
        console.log("ggggggggggggggggggggggggggg");
        let cookiesData = sessionStorage.getItem('userData');
        let cookiesJSONData = JSON.parse(cookiesData);
        PostData('profile', {id:cookiesJSONData.id}).then((result) => {
            console.log("FIRST NAME:::::",result.user.first_name);
            this.setState({
                            profileData: result.user,
                            first_name: result.user.first_name,
                            last_name: result.user.last_name,
                            mobile: result.user.mobile,
                            address: result.user.address,
                            panCard: result.user.panCard,
                            gender: result.user.gender,
                            license_no: result.user.license_no,
                            id: cookiesJSONData.id,
                        });
        });

    }
    editProfile() {
        this.setState({edit: !this.state.edit});
    }
    onChange(e){
        this.setState({[e.target.name]:e.target.value});
    }
    save() {
        this.setState({edit: !this.state.edit});
        PostData('update', this.state).then((result) => {
            console.log("XXXXXXXXXXX===", result.user);
            this.setState({profileData: result.user});
        });
    }
    editData() {
        return (
            
            <Table>
                <TableHead className="mb-4">
                    <TableRow>
                        <TableCell colspan= "2">
                            <h2>Welcome {this.state.profileData.first_name+" "+this.state.profileData.last_name} !!</h2>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>First Name</TableCell>
                        <TableCell>
                            <input type="text" name = "first_name" value={this.state.first_name} className="form-control form-control-lg" onChange={this.onChange} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Last Name</TableCell>
                        <TableCell>
                            <input type="text" name = "last_name" value={this.state.last_name} className="form-control form-control-lg" onChange={this.onChange} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Gender</TableCell>
                        <TableCell>
                            <input type="text" name = "gender" value={this.state.gender} className="form-control form-control-lg" onChange={this.onChange} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Address</TableCell>
                        <TableCell>
                            <input type="text" name = "address" value={this.state.address} className="form-control form-control-lg" onChange={this.onChange} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Pan Card</TableCell>
                        <TableCell>
                            <input type="text" name = "panCard" value={this.state.panCard} className="form-control form-control-lg" onChange={this.onChange} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>License No.</TableCell>
                        <TableCell>
                            <input type="text" name = "license_no" value={this.state.license_no} className="form-control form-control-lg" onChange={this.onChange} />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Email</TableCell>
                        <TableCell>
                            <input type="text" name = "email" value={this.state.profileData.email} className="form-control form-control-lg" />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Mobile Number</TableCell>
                        <TableCell>
                            <input type="text" name = "mobile" value={this.state.mobile} className="form-control form-control-lg" onChange={this.onChange} />
                        </TableCell>
                    </TableRow>
                </TableBody>
                <TableHead className="mb-4">
                    <TableRow>
                        <TableCell colspan= "2">
                            <button className="btn jr-btn-rounded btn-primary btn-rounded" onClick={this.save}>
                                Save
                            </button>
                        </TableCell>
                    </TableRow>
                </TableHead>
            </Table>
        );
    }
    dispalyProfile() {
        return(
            <Table>
                <TableHead className="mb-4">
                    <TableRow>
                        <TableCell colspan= "2">
                            <h2>Welcome {this.state.profileData.first_name+" "+this.state.profileData.last_name} !!</h2>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>First Name</TableCell>
                        <TableCell>{this.state.profileData.first_name}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Last Name</TableCell>
                        <TableCell>{this.state.profileData.last_name}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Gender</TableCell>
                        <TableCell>{this.state.profileData.gender}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Address</TableCell>
                        <TableCell>{this.state.profileData.address}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Pan Card</TableCell>
                        <TableCell>{this.state.profileData.panCard}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>License No.</TableCell>
                        <TableCell>{this.state.profileData.license_no}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Email Id</TableCell>
                        <TableCell>{this.state.profileData.email}</TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>Mobile Number</TableCell>
                        <TableCell>{this.state.profileData.mobile}</TableCell>
                    </TableRow>
                </TableBody>
                <TableHead className="mb-4">
                    <TableRow>
                        <TableCell colspan= "2">
                            <button className="btn jr-btn-rounded btn-primary btn-rounded" onClick ={this.editProfile} >
                                Edit
                            </button>
                        </TableCell>
                    </TableRow>
                </TableHead>
            </Table>

        );
    }
    render() {
        let cookiesData = sessionStorage.getItem('userData');
        
        console.log(this.state);       
        if(cookiesData) {
            return (
                <div className="dashboard animated slideInUpTiny animation-duration-3">
                    <ContainerHeader match={this.props.match} title="Welcome to Admin Panel"/>
                    <div className="table-responsive-material">
                        {!this.state.edit && this.dispalyProfile()}
                        {this.state.edit && this.editData()}
                    </div>
                </div>               
            );
        } else {
            return ( <Redirect to={'/login'}/> );
        }
    }
}

export default Default;


// WEBPACK FOOTER //
// ./app/routes/dashboard/routes/Default/index.js